import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
// material
import { Box } from "@mui/material";

function getTitle() {
  if (window.global.isKs) {
    return "Körtillstånd";
  } else if (window.global.isEcomp) {
    return "eComp";
  } else {
    return "Instructor Portal";
  }
}

// ----------------------------------------------------------------------
//const kortillstandSE= (window.location.host.indexOf('kortillstand.se') !== -1);
const Page = forwardRef(({ children, title = `${getTitle()} ${sessionStorage.companyName || ""}`, ...other }, ref) => (
  <Box ref={ref} {...other}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
  </Box>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
